import React, { Fragment, useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import ConfigControl from '../../../components/ConfigControl';
import { FieldsMode, MonitorConfig } from '../../../helpers/constants';
import MonitorContext from '../MonitorContext';
import { colors } from '../WindowConfig';
import Cell from './common/Cell';
import Column from './common/Column';
import DataCell from './common/DataCell';
import LongStyledButton from './common/LongStyledButton';
import MonitorField from './common/MonitorField';
import MonitorLabel from './common/MonitorLabel';
import Row from './common/Row';
import UnitContainer from './common/UnitContainer';

export interface IAuxInfoAreaProps {
  currentConfig: string;
}

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const CustomRow = styled(Row)<any>`
  justify-content: space-between;
`;

const CustomColumn = styled(Column)<any>`
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  width: 40px;
  height: 40px;
`;

const LinkContainer = styled(Container)`
  flex-direction: row;
`;

export default function AuxInfoArea({ currentConfig }: IAuxInfoAreaProps) {
  const { auxMode, showMobIcon } = useSelector(
    (state: any) => state.executor.s80.monitorFieldModes
  );
  const { monitor: presentMonitor } = useContext(MonitorContext);
  const monitorAuxMode = auxMode[presentMonitor];
  return (
    <Fragment>
      <ConfigControl elementFor={MonitorConfig.SONAR} config={currentConfig}>
        <Container>
          <Row>
            <Cell>
              <MonitorLabel field="aux-info-area-1" />
            </Cell>
            <DataCell width="55%">
              <MonitorField field="aux-info-area-1" />
            </DataCell>
          </Row>
          <Row>
            <Cell>
              <MonitorLabel field="aux-info-area-2" />
            </Cell>
            <DataCell width="55%">
              <MonitorField field="aux-info-area-2" />
            </DataCell>
          </Row>
          <Row>
            <Cell>
              <MonitorLabel field="aux-info-area-3" />
            </Cell>
            <DataCell width="55%">
              <MonitorField field="aux-info-area-3" />
            </DataCell>
          </Row>
          <Row>
            <Cell>
              <MonitorLabel field="aux-info-area-4" />
            </Cell>
            <DataCell width="55%">
              <MonitorField field="aux-info-area-4" />
            </DataCell>
          </Row>
        </Container>
      </ConfigControl>
      <ConfigControl elementFor={MonitorConfig.TACTICO} config={currentConfig}>
        <ConfigControl elementFor={FieldsMode.MOB} config={monitorAuxMode}>
          <Container>
            <CustomRow>
              <CustomColumn width="15%">
                {showMobIcon && (
                  <>
                    MOB
                    <Image
                      src={require('../../../assets/images/s80/mcb.png')}
                    />
                  </>
                )}
              </CustomColumn>
              <Column width="80%">
                <Row>
                  <Cell width="20%">
                    <MonitorLabel field="aux-info-area-mob-1" />
                  </Cell>
                  <DataCell width="55%">
                    <MonitorField field="aux-info-area-mob-1" />
                  </DataCell>
                  <UnitContainer field="aux-info-area-mob-1" />
                </Row>
                <Row>
                  <Cell width="20%">
                    <MonitorLabel field="aux-info-area-mob-2" />
                  </Cell>
                  <DataCell width="55%" l>
                    <MonitorField field="aux-info-area-mob-2" />
                  </DataCell>
                  <UnitContainer field="aux-info-area-mob-2" />
                </Row>
                <Row>
                  <Cell width="20%">
                    <MonitorLabel field="aux-info-area-mob-3" />
                  </Cell>
                  <DataCell width="55%">
                    <MonitorField field="aux-info-area-mob-3" />{' '}
                  </DataCell>
                  <UnitContainer field="aux-info-area-mob-3" />
                </Row>
              </Column>
            </CustomRow>
          </Container>
        </ConfigControl>
        <ConfigControl
          elementFor={FieldsMode.PERISCOPE}
          config={monitorAuxMode}
        >
          <Container>
            <CustomRow>
              <Column width="80%">
                <Row>
                  <Cell width="30%">
                    <MonitorLabel field="aux-info-area-periscope-1" />
                  </Cell>
                  <DataCell width="30%">
                    <MonitorField field="aux-info-area-periscope-1" />
                  </DataCell>
                </Row>
                <Row>
                  <Cell width="30%">
                    <MonitorLabel field="aux-info-area-periscope-2" />
                  </Cell>
                  <DataCell width="30%" l>
                    <MonitorField field="aux-info-area-periscope-2" />
                  </DataCell>
                </Row>
              </Column>
            </CustomRow>
          </Container>
        </ConfigControl>
        <ConfigControl elementFor={FieldsMode.NAVAID} config={monitorAuxMode}>
          <Container>
            <CustomRow>
              <Column width="100%">
                <Row
                  style={{
                    justifyContent: 'space-evenly',
                    height: '36px',
                    marginBottom: '7px',
                  }}
                >
                  <LongStyledButton
                    style={{
                      textTransform: 'capitalize',
                    }}
                    endWithColon={false}
                    field="aux-info-area-navaid-1"
                  />
                  <LongStyledButton
                    style={{ textTransform: 'capitalize' }}
                    endWithColon={false}
                    field="aux-info-area-navaid-4"
                  />
                  <LongStyledButton
                    style={{ textTransform: 'capitalize' }}
                    endWithColon={false}
                    field="aux-info-area-navaid-5"
                  />
                </Row>
                <Row>
                  <Cell width="22%">
                    <MonitorLabel field="aux-info-area-navaid-2" />
                  </Cell>
                  <DataCell width="22%">
                    <MonitorField field="aux-info-area-navaid-2" />
                  </DataCell>
                  <UnitContainer
                    style={{ width: '6%' }}
                    field="aux-info-area-navaid-2"
                  />

                  <Cell width="22%">
                    <MonitorLabel field="aux-info-area-navaid-3" />
                  </Cell>
                  <DataCell width="22%">
                    <MonitorField field="aux-info-area-navaid-3" />
                  </DataCell>
                  <UnitContainer
                    style={{ width: '6%' }}
                    field="aux-info-area-navaid-3"
                  />
                </Row>
                <Row>
                  <Cell width="22%">
                    <MonitorLabel field="aux-info-area-navaid-6" />
                  </Cell>
                  <DataCell width="22%">
                    <MonitorField field="aux-info-area-navaid-6" />
                  </DataCell>
                  <UnitContainer
                    style={{ width: '6%' }}
                    field="aux-info-area-navaid-6"
                  />

                  <Cell width="22%">
                    <MonitorLabel field="aux-info-area-navaid-7" />
                  </Cell>
                  <DataCell width="22%">
                    <MonitorField field="aux-info-area-navaid-7" />
                  </DataCell>
                  <UnitContainer
                    style={{ width: '6%' }}
                    field="aux-info-area-navaid-7"
                  />
                </Row>
              </Column>
            </CustomRow>
          </Container>
        </ConfigControl>
      </ConfigControl>
      <ConfigControl
        elementFor={[MonitorConfig.LINK, MonitorConfig.SISTEMA]}
        config={currentConfig}
      >
        <LinkContainer>
          <Column width="45%">
            <Row>
              <Cell></Cell>
              <DataCell width="55%"></DataCell>
            </Row>
            <Row>
              <Cell></Cell>
              <DataCell width="55%"></DataCell>
            </Row>
            <Row>
              <Cell></Cell>
              <DataCell width="55%"></DataCell>
            </Row>
            <Row>
              <Cell></Cell>
              <DataCell width="55%"></DataCell>
            </Row>
          </Column>
          <Column width="45%">
            <Row>
              <Cell></Cell>
              <DataCell width="55%"></DataCell>
            </Row>
            <Row>
              <Cell></Cell>
              <DataCell width="55%"></DataCell>
            </Row>
            <Row>
              <Cell></Cell>
              <DataCell width="55%"></DataCell>
            </Row>
            <Row>
              <Cell></Cell>
              <DataCell width="55%"></DataCell>
            </Row>
          </Column>
        </LinkContainer>
      </ConfigControl>
    </Fragment>
  );
}
